export const localizeCurrency = (number: number) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(number);
